import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Progress,message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select,DatePicker,Upload, Modal,   } from 'antd';
import {  LineOutlined,DoubleRightOutlined,DoubleLeftOutlined} from '@ant-design/icons';


const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;

const buttonWidth = 70;




class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			name : '',
			sequence : '',
			loading: false,
			tag_name: [],
		}
		this.handleSizeChange = this.handleSizeChange.bind(this);	
		this.goBack = this.goBack.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		
		
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],program_id : this.props.match.params.id,school_id : storedArray['data'][0]['school_id'] });
		}
	}
	
	handleSizeChange = e => {		
		this.setState({ [e.target.name]: e.target.value });	
	 };
	  
	  handleSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
		this.setState({ loading: true });
		
		var app = {
			user_id : this.state.user_id,
			school_id : this.state.school_id,
			name : this.state.name
		}
		getData('erp/add_subject',app).then((result) => {
			if(result.status==400){
				message.config({ top: 150});
				message.error(result.message,2);
				this.setState({ loading: false });
			}
			else if(result.status==200){
				message.config({ top: 150});
				message.success('Subject added',2);
				this.setState({ loading: false });
				window.location.href = '/manage-class/subject';
			}
			else{
				this.setState({ loading: false });
			}
		});
	  }else{
		message.error('Please Login',2);	
	  }

	}
  
	goBack(){
		window.location.href = '/admissions/enquiries';
	}

	render()

	{
	
	const { size } = this.state;
	const { previewVisible, previewImage, fileList, previewTitle } = this.state;
					
		return (
			<>
			
			<div class="mobile_view">
			<div class="row bred">
				<div class="col-md-12">
					<div class="card">
						<div class="card-body">
							<h4 class="page-title"> 
								<i class="mdi mdi-apple-keyboard-command title_icon"></i>Add Subject

								<div class="breadcrumb-wrapper">
									<ol class="breadcrumb">
										<li class="breadcrumb-item">
											<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
											<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
											</a>
										</li>
										<li class="breadcrumb-item"> <a href={`${process.env.PUBLIC_URL}/manage-class/subject`} class="router-link-active" target="_self">Manage Subject</a></li>
										<li class="breadcrumb-item"> Add Subject</li>

									</ol>
								</div>
							</h4>
						</div>
					</div>
				</div>
			</div>
			
			<div id="main" class="bg-off">
			<div class="row">
            <div class="col col-md-12  ex-padd">
			
			<div class="view-Profile child-profile view-Profile-mobile">
			   <div class="mb-20 card-content iq-card">
                  <section class="invoice-list-wrapper section food ">
					<div class="children mb-2  iq-card2 flow-root">
                     
						<div class="bb d-flex">
						  
						  <div class="col col-md-12 s12 fees form-group">
						  <div class="row">
								<div class="col-md-6  mb-20 mt-10">
									<label>Name</label>
									<input type="text" class="form-control"  name="name" value={this.state.name} onChange={this.handleSizeChange}  required />
								</div>
								</div>									
						  </div>
						</div>
					</div> 
					
					
					<div class="col col-md-12 s12 meal bt pt-10 mb-10 text-center">
						 <Button className="btn btn-primary mr-2" id="submit_btn" onClick={this.handleSubmit} loading={this.state.loading}>Submit</Button>
					</div>
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		</>	
		) 
	} 
}
export default Index;
